/**
 * Represents a generic button.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import templates from "../../../utils/templates";

const channel = Radio.channel("global");
const DEFAULTS = {
  tagName: "button",
  attributes: {
    type: "button",
  },
  template: templates.find("layout", "generic_button"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // does this button support an event?
    if (this.model.get("eventName")) {
      // attach click event if it has a datasource
      if (this.model.get("datasource")) {
        this.$el.on("click", this._handleClick.bind(this));
      } else {
        // otherwise disable the button
        this.$el.addClass("disabled");
      }
    }
  }

  _handleClick(e) {
    e.preventDefault();
    // trigger custom event and return the datasource
    channel.trigger(this.model.get("eventName"), this.model.get("datasource"));
  }
}

export { View as default };
